// Homepage intro loader — first visit per session only.
// Gating also happens inline in theme.liquid so the overlay never even
// renders on subsequent pageviews; this script just handles the fade-out.

(function () {
  var loader = document.getElementById('PageLoader');
  if (!loader) return;

  var MIN_VISIBLE_MS = 900; // keep the logo on screen at least this long
  var shownAt = Date.now();

  function hide() {
    var elapsed = Date.now() - shownAt;
    var wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
    setTimeout(function () {
      loader.classList.add('is-hidden');
      document.documentElement.classList.remove('page-loader-active');
      try {
        sessionStorage.setItem('moravianLoaderShown', '1');
      } catch (e) {
        // Private mode etc. — ignore.
      }
      // Remove from DOM after the fade completes so it can't catch clicks.
      setTimeout(function () {
        if (loader && loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 500);
    }, wait);
  }

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', hide, { once: true });
  }

  // Safety net — never trap the user behind the loader.
  setTimeout(function () {
    if (loader && !loader.classList.contains('is-hidden')) {
      hide();
    }
  }, 4000);
})();
